<template>
  <vx-card>
    <div class="mt-5">
      <div v-if="this.id_proveedor>0"> 
          <h4>Edita tu proveedor Vivotek</h4>
        </div>
        <div v-else> 
          <h4>Registra tu proveedor Vivotek</h4>
        </div>
      <form-wizard ref="wizard" color="rgba(var(--vs-primary), 1)" nextButtonText="Siguiente" backButtonText="Regresar" finishButtonText="Guardar" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" f>
        <tab-content title="Proveedor" class="mb-5" icon="feather icon-home" :before-change="validateStep1">
          <!-- tab 1 content -->
          <form data-vv-scope="step-1">
          <div class="vx-row">
            <div class="vx-col md:w-3/5 w-full mt-5">
              <label class="vs-input--label">Proveedor</label>
              <v-select v-model="Proveedor" class="w-full select-large" name="proveedor_id" v-validate="'required'" label="razon_social" :options="dataProve" placeholder="Elige una opción"><span slot="no-options">Ya no hay mas proveedores con quien registrar.</span></v-select>
              <span class="text-danger">{{ errors.first('step-1.proveedor_id') }}</span>
            </div>
            <div class="vx-col md:w-2/5 w-full mt-5">
              <vs-input label="No. Cliente" v-model="noCliente" class="w-full" name="no_cuenta" v-validate="'required'" />
              <span class="text-danger">{{ errors.first('step-1.no_cuenta') }}</span>
            </div>
          </div>
          </form>
        </tab-content>
        <!-- tab 2 content -->
        <tab-content title="Agente de Ventas" class="mb-5"  icon="feather icon-user" :before-change="validateStep2">
          <form data-vv-scope="step-2">
            <div class="vx-row">
              <div class="vx-col md:w-2/3 w-full">
                <vs-input label="Nombre del Agente" v-model="nombreAgente" class="w-full mt-4" name="nombre_a" v-validate="'required|alpha_spaces'" />
                <span class="text-danger">{{ errors.first('step-2.nombre_a') }}</span>
              </div>
              <div class="vx-col md:w-1/3 w-full">&nbsp;</div>
              <div class="vx-col md:w-2/5 w-full">
                <vs-input label="Teléfono  del Agente"  v-model="telAgente" class="w-full mt-4" name="telefono_a" v-validate="'required'" />
                <span class="text-danger">{{ errors.first('step-2.telefono_a') }}</span>
              </div>
              <div class="vx-col md:w-2/5 w-full">
                <vs-input label="Email  del Agente"  v-model="correoAgente" class="w-full mt-4" name="email_a" v-validate="'required|email'" />
                <span class="text-danger">{{ errors.first('step-2.email_a') }}</span>
              </div>
            </div>
          </form>
        </tab-content>
       
      </form-wizard>
    </div>
  </vx-card> 
</template>
<script>

import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import axios from '../../axios.js'
import vSelect from 'vue-select'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect);

// For custom error message
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    no_cuenta: {
      required: 'No de cuenta es requerido'
    },
    proveedor_id: {
      required: 'El proveedor es requerido',
    }
  }
}
// register custom messages
Validator.localize('es', dict)
export default {
  data () {
    return {
      noCliente: '',
      Proveedor: null,
      nombreAgente: '',
      telAgente: '',
      correoAgente: '',
      dataProve: [],
      id_proveedor: 0,
    }
  },
  methods: {
    init(){
      this.openLoading();
      if(this.id_proveedor>0){
        this.consultarinfo();
      } else {
        this.verProvedores(0);
      }
    },
    openLoading(){
      this.$vs.loading({type:'corners'});
    },
    closeLoading(){
      this.$vs.loading.close();
    },
    consultarinfo(){
      const proveedor = this.id_proveedor;
      this.$http.post('Distribuidores','ObtenerIntegrador',{proveedor},(data)=>{
        this.noCliente = data.id_cliente;
        this.Proveedor = { id: data.distribuidor_id , razon_social:data.razon_social };
        this.nombreAgente = data.agente_nombre;
        this.telAgente = data.agente_tel;
        this.correoAgente = data.agente_correo;
        this.dist = data.distribuidor_id;
        this.verProvedores(this.dist);
        this.closeLoading();
      });
    },
    validateStep1 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateStep2 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-2').then(result => {
          if (result) {
            const POST = {
              id: this.id_proveedor,
              id_cliente: this.noCliente,
              distribuidor_id: this.Proveedor.id,
              agente_nombre: this.nombreAgente,
              agente_tel: this.telAgente,
              agente_correo: this.correoAgente
            };
            this.openLoading();
            this.$http.post('Distribuidores','agregarProveedor',{POST},(data)=>{
              if(data == 2){
                this.$swal.fire(
                  'Proveedor',
                  'Registrado correctamente!',
                  'success'
                );
                this.$router.push('/proveedores_lista').catch(() => {});
              } else if(data == 1){
                this.$swal.fire(
                  'Proveedor',
                  'Editado correctamente!',
                  'success'
                );
                this.$router.push('/proveedores_lista').catch(() => {})
              }else {
                this.$swal.fire(
                  'Proveedor',
                  'error al registrar intenta de nuevo mas tarde!',
                  'error'
                );                
              }
              this.closeLoading();
            });
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    verProvedores(dist){
      let proveedor_id = this.id_proveedor;
      this.$http.post('Distribuidores','DistribuidoresDisponibles',{proveedor_id},(data)=>{
        let dataP = [];
        data.forEach((value, index) => {
          dataP.push(value);
        });
        if(dataP){
        }else{
          dataP = array("razon_social" , "Ya no hay mas proveedores con quien registrarte.")
        }
        this.dataProve = dataP;
        this.closeLoading();
      });
    }
  },
  components: {
    FormWizard,
    TabContent
  },
  mounted() {
    this.id_proveedor = this.$route.params.id ? this.$route.params.id : 0;
    this.init();
  },                   
}
</script>